import { Navigate, Route, Routes } from "react-router-dom";
import { Login } from "./components/login/Login";
import "./auth.scss";

export const Auth = () => {
	return (
		<div className='auth'>
			<div className='auth__container'>
				<Routes>
					{/* При входе на пустой auth/ редиректим на относительный путь auth/login */}
					<Route index element={<Navigate to='login' replace />} />
					{/* Роут для login */}
					<Route path='login' element={<Login />} />
					{/* При входе на любой другой путь auth/ редиректим на абсолютный путь auth/login */}
					<Route path='*' element={<Navigate to='/auth/login' replace />} />
				</Routes>
			</div>
		</div>
	);
};
